import { ChatAgentType } from '@constants/chat-agents';
import type { ChatMessage } from '../types';

const STORAGE_KEY = 'chat_history';
const CURSOR_KEY = 'chat_cursors';


export const saveChatHistories = (
  histories: Record<ChatAgentType, ChatMessage[]>
): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(histories));
  } catch (error) {
    console.error('[ChatStorage] Error saving chat histories:', error);
  }
};


export const saveCursors = (
  cursors: Record<ChatAgentType, string | null>
): void => {
  try {
    localStorage.setItem(CURSOR_KEY, JSON.stringify(cursors));
  } catch (error) {
    console.error('[ChatStorage] Error saving cursors:', error);
  }
};


export const loadChatHistories = (): Record<ChatAgentType, ChatMessage[]> | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch (error) {
    console.error('[ChatStorage] Error loading chat histories:', error);
    return null;
  }
};

export const loadCursors = (): Record<ChatAgentType, string | null> | null => {
  try {
    const stored = localStorage.getItem(CURSOR_KEY);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch (error) {
    console.error('[ChatStorage] Error loading cursors:', error);
    return null;
  }
};

export const clearChatStorage = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(CURSOR_KEY);
  } catch (error) {
    console.error('[ChatStorage] Error clearing chat storage:', error);
  }
};
